export default {
    companies: null,
    error: null,
    errorShow: false,
    loading: false
}